import { createTheme } from "@material-ui/core/styles";

export const theme = createTheme({
	palette: {
		primary: {
			main: "#000000",
		},
		secondary: {
			main: "#DE0038",
		},
	},
});
